"use strict";

exports.__esModule = true;
exports.default = void 0;
// 3.0 fields without app review https://developers.facebook.com/docs/facebook-login/permissions/?locale=en_US#reference-default
var _default = ['id', 'first_name', 'last_name', 'middle_name', 'name', 'name_format', 'picture', 'short_name', 'email'];
exports.default = _default;
//# sourceMappingURL=Fields.js.map